export default __webpack_public_path__ + "static/media/RTP5.782f7ea4.webp";